var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoggingService as logger } from "@/logging/LoggingService";
import { getActivityState, setActivityState } from "../cmi5Api/activityState";
export const LrsStatement = {
    /**
     * Retrieve the activity state for this learner and registration at the given stateId.
     *
     * @param {string} stateId     The xAPI Activity State "stateId" value for the API call.
     * @return {Promise<Response>} The learner's data for stateId, or "" if no suspend data exists.
     */
    get: (stateId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getActivityState(stateId);
            if (response) {
                return Promise.resolve(response);
            }
            else {
                logger.debug("No data for stateId:".concat(stateId));
            }
        }
        catch (e) {
            logger.error(`failed to get data for ${stateId}: ${e}!`);
        }
        return Promise.resolve(undefined);
    }),
    /**
     * Save the learner's data.
     *
     * @param {string} stateId     The xAPI Activity State "stateId" value for the API call.
     * @param data                 The data to store in this Activity State.
     *
     * @return {Promise<string>} The promise returned by the fetch call representing the xAPI request.
     */
    set: (stateId, data) => __awaiter(void 0, void 0, void 0, function* () {
        if (!data) {
            return Promise.reject("Invalid data object!");
        }
        try {
            const response = yield setActivityState(stateId, data);
            return Promise.resolve(response);
        }
        catch (e) {
            logger.error(`failed to get data for ${stateId}: ${e}!`);
        }
    })
};
